import React from 'react'
import { Typography } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { ErrorCircleIcon } from '../Icon'
import { ICON_SIZE } from '../Icon/constants'
import { ErrorMessageContainer, ErrorText } from './styles'
import type { ErrorMessageProps } from './types'

const ErrorMessage: React.FC<ErrorMessageProps> = ({ children, hasError, errorMessage }) => {
  const { t } = useFavurTranslation()

  if (!hasError) return <>{children}</>

  const message = errorMessage ?? t('error.default')

  return (
    <ErrorMessageContainer>
      {children}
      <ErrorText>
        <ErrorCircleIcon isFilled size={ICON_SIZE.extraSmall} />
        <Typography variant="caption" color="error">
          {message}
        </Typography>
      </ErrorText>
    </ErrorMessageContainer>
  )
}

export default ErrorMessage
